import * as React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmCommissionActionDialogProps {
    dialogName: string;
    hideDialog: () => void;
    heading?: string;
    label?: string;
    confirmText?: string;
    loadingText?: string;
    loading?: boolean;
    onConfirm: () => void;
}

// Same shape as ConfirmGenerateInvoiceDocumentsDialog - shared by Approve/Rebuild/Build Manager
// Review since they're all just an "are you sure" gate in front of a mutating action, differing
// only in text. Build Manager Review additionally uses `loading` to keep the dialog open with a
// spinner for the (long-running, whole-period) call rather than dismissing immediately like
// Approve/Rebuild do.
const ConfirmCommissionActionDialog = (props: IConfirmCommissionActionDialogProps) => {
    return (
        <Dialog title={props?.heading ? props?.heading : ''} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{props?.label ?? ''}</label>
                </form>
            </div>
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={props.loading ? (props?.loadingText ?? 'Working...') : (props?.confirmText ?? 'Confirm')}
                    loading={props.loading}
                    disabled={props.loading}
                    onClick={() => props.onConfirm()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '20%', marginRight: '1rem' }}
                    text="Cancel"
                    disabled={props.loading}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default ConfirmCommissionActionDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/ConfirmCommissionActionDialog.tsx